import React from 'react';
import { AlertTriangleIcon, ClockIcon, FileSignatureIcon, InboxIcon, MapIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
import { dispatchFeatures } from '../data/content';
import { Reveal } from './showcase/Reveal';
const icons = {
  map: MapIcon,
  clock: ClockIcon,
  alert: AlertTriangleIcon,
  users: UsersIcon,
  shield: ShieldCheckIcon,
  inbox: InboxIcon,
  signature: FileSignatureIcon
};
export function DispatchBrain() {
  return <section id="dispatch" aria-labelledby="dispatch-title" className="border-b border-white/5 bg-ink-900" data-id="element-80" data-mp="qdaf0vtaevjm">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-81" data-mp="105zltddw7l8m">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-82" data-mp="v6d9d65w290v">
          The dispatch brain
        </p>
        <h2 id="dispatch-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-83" data-mp="1a2ukbwa61lmw">
          Not an answering machine. A dispatch brain for your team.
        </h2>

        <div className="mt-12 grid gap-px overflow-hidden rounded-xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-84" data-mp="1y8a5iv6dbp3e">
          {dispatchFeatures.map((feature, index) => {
          const Icon = icons[feature.icon];
          return <Reveal key={feature.title} delay={0.06 * index} offset={12} className="h-full" data-id="element-85" data-mp="2c71haaxrcyod" data-mpi={index}>
                <div className="h-full bg-ink-800 p-7" data-id="element-86" data-mp="2m3miel6nppmx">
                  <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-87" data-mp="2m21pt13wkgrp" />
                  <h3 className="mt-5 font-display text-lg font-semibold tracking-tight text-white" data-id="element-88" data-mp="2qw5zvt8gt4x0">
                    {feature.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-89" data-mp="2zw2ro3q5ijwa">
                    {feature.body}
                  </p>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}